// assets/cart-drawer-recommendations.js
console.log('[Cart Upsell] loaded');

const SELECTOR_MOUNT = '.cart-drawer__recommendations';
const SELECTOR_GRID = '.cart-upsell__grid';

let currentAbort = null;

function money(cents, currency = 'PKR') {
  const value = (cents / 100).toFixed(0);
  return `${currency} ${value}`;
}

async function fetchJSON(url, { signal } = {}) {
  const res = await fetch(url, { signal, headers: { Accept: 'application/json' } });
  if (!res.ok) throw new Error(`Request failed: ${res.status}`);
  return res.json();
}

function getMounts() {
  return Array.from(document.querySelectorAll(SELECTOR_MOUNT));
}

function setLoading(grid) {
  grid.innerHTML = `
    <div style="padding:12px;border:1px dashed rgba(0,0,0,.15);border-radius:10px">
      Loading recommendations…
    </div>
  `;
}

function setEmpty(grid) {
  grid.innerHTML = `
    <div style="padding:10px;border:1px dashed rgba(0,0,0,.12);border-radius:10px">
      No recommendations right now.
    </div>
  `;
}

function renderProducts(grid, products) {
  grid.innerHTML = `
    <div class="cart-upsell" data-upsell>
      <button class="cart-upsell__nav cart-upsell__nav--prev" type="button" aria-label="Previous">‹</button>

      <div class="cart-upsell__viewport" data-upsell-viewport>
        <div class="cart-upsell__track" data-upsell-track>
          ${products
            .map((p) => {
              const img = p.featured_image || (p.images && p.images[0]) || '';
              const variantId = p.variants?.[0]?.id;
              const price = p.price ?? p.variants?.[0]?.price ?? 0;

              return `
                <div class="cart-upsell__slide" data-upsell-slide>
                  <div class="cart-upsell__card">
                    ${img ? `<img class="cart-upsell__img" src="${img}" alt="${p.title}">` : ''}

                    <div class="cart-upsell__meta">
                      <div class="cart-upsell__title">${p.title}</div>
                      <div class="cart-upsell__price">${money(
                        price,
                        window?.Shopify?.currency?.active || 'PKR'
                      )}</div>

                      ${
                        p.variants && p.variants.length > 1
                          ? `
                            <select class="cart-upsell__variant-select" data-variant-select>
                              <option value="">Select size</option>
                              ${p.variants
                                .map(
                                  (v) => `
                                    <option
                                      value="${v.id}"
                                      ${v.available ? '' : 'disabled'}
                                      data-price="${v.price}"
                                      data-compare-at-price="${v.compare_at_price ?? v.price}"
                                    >
                                      ${v.title}${v.available ? '' : ' — Sold out'}
                                    </option>
                                  `
                                )
                                .join('')}
                            </select>
                          `
                          : `
                            <input type="hidden" data-variant-id="${p.variants?.[0]?.id || ''}">
                          `
                      }
                    </div>

                    <button
                      class="cart-upsell__add button"
                      type="button"
                      data-variant-id=""
                      ${p.variants && p.variants.length > 1 ? 'disabled' : variantId ? '' : 'disabled'}
                    >
                      Add
                    </button>
                  </div>
                </div>
              `;
            })
            .join('')}
        </div>
      </div>

      <button class="cart-upsell__nav cart-upsell__nav--next" type="button" aria-label="Next">›</button>
    </div>
  `;

  // Add buttons
  grid.querySelectorAll('.cart-upsell__add').forEach((btn) => {
    btn.addEventListener('click', onAddClick, { once: true });
  });

  // Bind variant selects (no auto-select)
  grid.querySelectorAll('.cart-upsell__card').forEach((card) => {
    const select = card.querySelector('[data-variant-select]');
    const hidden = card.querySelector('input[data-variant-id]');
    const btn = card.querySelector('.cart-upsell__add');

    if (!btn) return;

    // Single-variant products
    if (hidden && hidden.dataset.variantId) {
      btn.setAttribute('data-variant-id', hidden.dataset.variantId);
      btn.disabled = false;
      return;
    }

    // Multi-variant products: require selection
    if (!select) return;

    btn.disabled = true;
    btn.setAttribute('data-variant-id', '');

    select.addEventListener('change', (e) => {
      const val = e.target.value;
      btn.setAttribute('data-variant-id', val || '');
      btn.disabled = !val;
    });
  });

  initCarousel(grid);
}

function initCarousel(root) {
  const viewport = root.querySelector('[data-upsell-viewport]');
  const track = root.querySelector('[data-upsell-track]');
  const prev = root.querySelector('.cart-upsell__nav--prev');
  const next = root.querySelector('.cart-upsell__nav--next');
  if (!viewport || !track || !prev || !next) return;

  const snapToIndex = (index) => {
    const slide = track.children[index];
    if (!slide) return;
    slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
  };

  const getIndex = () => {
    const slides = Array.from(track.children);
    const left = viewport.scrollLeft;
    let best = 0;
    let bestDist = Infinity;
    slides.forEach((s, i) => {
      const dist = Math.abs(s.offsetLeft - left);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    });
    return best;
  };

  prev.addEventListener('click', () => snapToIndex(Math.max(0, getIndex() - 1)));
  next.addEventListener('click', () =>
    snapToIndex(Math.min(track.children.length - 1, getIndex() + 1))
  );
}

/* ===============================
   Decoy-style add (sections patch)
   =============================== */

function getCartDrawerSectionId() {
  const cartItems = document.querySelector('cart-drawer-component cart-items-component[data-section-id]');
  return cartItems?.getAttribute('data-section-id') || null;
}

function replaceFromSectionsHTML(sectionHTML, { rootSelector, replacementSelector }) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(sectionHTML, 'text/html');

  const incoming = doc.querySelector(replacementSelector);
  const current = document.querySelector(rootSelector);

  if (!incoming || !current) return false;

  current.replaceWith(incoming);
  document.dispatchEvent(new CustomEvent('cart:dom-updated', { detail: { root: incoming } }));
  return true;
}

async function onAddClick(e) {
  const btn = e.currentTarget;
  const variantId = btn?.getAttribute('data-variant-id');
  if (!variantId) return;

  btn.disabled = true;
  btn.textContent = 'Adding…';

  try {
    const sectionId = getCartDrawerSectionId();
    const sectionsUrl = window.location.pathname + window.location.search;

    const formData = new FormData();
    formData.append('id', String(Number(variantId)));
    formData.append('quantity', '1');

    if (sectionId) {
      formData.append('sections', sectionId);
      formData.append('sections_url', sectionsUrl);
    }

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    });

    if (!res.ok) throw new Error(`Add failed: ${res.status}`);
    const data = await res.json();

    if (sectionId && data?.sections?.[sectionId]) {
      const ok = replaceFromSectionsHTML(data.sections[sectionId], {
        rootSelector: 'cart-drawer-component cart-items-component[data-section-id]',
        replacementSelector: 'cart-items-component[data-section-id]',
      });

      if (!ok) {
        document.dispatchEvent(new CustomEvent('cart:dom-updated', { detail: { root: document.body } }));
      }
    } else {
      document.dispatchEvent(new CustomEvent('cart:dom-updated', { detail: { root: document.body } }));
    }

    // ✅ IMPORTANT: do NOT call initUpsell here.
    // cart:dom-updated already re-runs initUpsell. Double-calling causes Abort + stuck loading.
  } catch (err) {
    console.error('[Cart Upsell] add failed', err);
  } finally {
    if (document.contains(btn)) {
      btn.disabled = false;
      btn.textContent = 'Add';
    }
  }
}

/* ===============================
   Upsell init
   =============================== */

async function initUpsell() {
  const mounts = getMounts();
  if (!mounts.length) return;

  if (currentAbort) currentAbort.abort();
  currentAbort = new AbortController();
  const { signal } = currentAbort;

  for (const mount of mounts) {
    const grid = mount.querySelector(SELECTOR_GRID);
    if (!grid) continue;

    if (mount.dataset.upsellBusy === '1') continue;
    mount.dataset.upsellBusy = '1';

    try {
      setLoading(grid);

      const cart = await fetchJSON('/cart.js', { signal });
      const items = cart?.items || [];
      if (!items.length) {
        setEmpty(grid);
        continue;
      }

      const seedProductId = items[0]?.product_id;
      if (!seedProductId) {
        setEmpty(grid);
        continue;
      }

      const inCartProductIds = new Set(items.map((i) => i.product_id));

      const rec = await fetchJSON(
        `/recommendations/products.json?product_id=${seedProductId}&limit=8&intent=related`,
        { signal }
      );

      const products = (rec?.products || []).filter((p) => !inCartProductIds.has(p.id)).slice(0, 4);

      if (!products.length) {
        setEmpty(grid);
        continue;
      }

      renderProducts(grid, products);
    } catch (err) {
      if (err?.name !== 'AbortError') console.error('[Cart Upsell] init failed', err);
    } finally {
      mount.dataset.upsellBusy = '0';
    }
  }
}

document.addEventListener('DOMContentLoaded', initUpsell);
document.addEventListener('cart:dom-updated', initUpsell);
document.addEventListener('cart:refresh-request', initUpsell);
